import { TrendingUp, TrendingDown, Minus, Users, MessageSquare, DollarSign } from 'lucide-react';

interface StatsCardSectionProps {
  todayLeads: number;
  yesterdayLeads: number;
  totalLeads: number;
  totalSpend: number;
}

function formatNumber(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toString();
}

export default function StatsCardSection({ todayLeads, yesterdayLeads, totalLeads, totalSpend }: StatsCardSectionProps) {
  const diff = yesterdayLeads > 0
    ? Math.round(((todayLeads - yesterdayLeads) / yesterdayLeads) * 100)
    : todayLeads > 0 ? 100 : 0;
  const isUp = diff > 0;
  const isDown = diff < 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Featured card — Leads hoy */}
      <div className="bg-[#1A4D2E] rounded-2xl p-5 flex flex-col justify-between min-h-[140px] shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between">
          <span className="text-[11px] uppercase tracking-wider text-emerald-300/70 font-medium">Leads hoy</span>
          <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center">
            <Users className="w-4 h-4 text-emerald-300" />
          </div>
        </div>
        <div>
          <p className="text-4xl font-bold text-white">{todayLeads}</p>
          <div className="flex items-center gap-1.5 mt-1">
            <div className={`flex items-center gap-0.5 text-xs font-medium ${
              isUp ? 'text-emerald-300' : isDown ? 'text-red-300' : 'text-white/50'
            }`}>
              {isUp ? <TrendingUp className="w-3 h-3" /> :
               isDown ? <TrendingDown className="w-3 h-3" /> :
               <Minus className="w-3 h-3" />}
              {isUp ? '+' : ''}{diff}%
            </div>
            <span className="text-[10px] text-white/40">vs ayer</span>
          </div>
        </div>
      </div>

      {/* Total leads */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex flex-col justify-between min-h-[140px] hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between">
          <span className="text-[11px] uppercase tracking-wider text-gray-400 font-medium">Total conversaciones</span>
          <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center">
            <MessageSquare className="w-4 h-4 text-gray-400" />
          </div>
        </div>
        <p className="text-4xl font-bold text-gray-900">{formatNumber(totalLeads)}</p>
      </div>

      {/* OpenRouter spend */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex flex-col justify-between min-h-[140px] hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between">
          <span className="text-[11px] uppercase tracking-wider text-gray-400 font-medium">Gasto OpenRouter</span>
          <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center">
            <DollarSign className="w-4 h-4 text-gray-400" />
          </div>
        </div>
        <p className="text-4xl font-bold text-gray-900">${totalSpend.toFixed(2)}</p>
      </div>
    </div>
  );
}
